import React from 'react';

const CyberpunkBackground = () => {
  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 0 }}
    >
      {/* Base dark background */}
      <div className="absolute inset-0 bg-[#020810]" />
      
      {/* Horizon glow */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 80% 40% at 50% 55%, rgba(0,120,150,0.12) 0%, transparent 70%)',
        }}
      />
      
      {/* Subtle top-down gradient for atmosphere */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(0,20,40,0.3) 0%, transparent 40%, rgba(0,15,25,0.35) 100%)',
        }}
      />

      {/* Grid lines - horizontal */}
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{
          height: '50%',
          backgroundImage: `
            linear-gradient(0deg, rgba(0,255,255,0.04) 1px, transparent 1px)
          `,
          backgroundSize: '100% 40px',
          maskImage: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.6))',
          WebkitMaskImage: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.6))',
        }}
      />

      {/* Grid lines - vertical perspective */}
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{
          height: '50%',
          backgroundImage: `
            linear-gradient(90deg, rgba(0,255,255,0.03) 1px, transparent 1px)
          `,
          backgroundSize: '120px 100%',
          maskImage: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.4))',
          WebkitMaskImage: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.4))',
        }}
      />

      {/* Vignette */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.45) 100%)',
        }}
      />
    </div>
  );
};

export default CyberpunkBackground;
